import { render, staticRenderFns, recyclableRender, components } from "./u-collapse-item.vue?vue&type=template&id=3bf52cdf&scoped=true&"
var renderjs
import script from "./u-collapse-item.vue?vue&type=script&lang=js&"
export * from "./u-collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./u-collapse-item.vue?vue&type=style&index=0&id=3bf52cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf52cdf",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-collapse-item/u-collapse-item.vue"
export default component.exports